//#region imports
import { GuaranteeService } from './guarantee.service';
import { Globals } from './globals';
import { SaveService } from 'src/app/services/save.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ContactDetails } from './../shared/model/save.model';
import {
  DocumentModel, CreerDossierIncendie, GarantiesContrat,
  GarantiesContenu, GarantiesBatiment, GarantieTarifee, Email
} from './../shared/model/document.model';
import { Injectable } from '@angular/core';
import { CharacteristicService } from './characteristic.service';
import { SignatureService } from './signature.service';
import { environment } from 'src/environments/environment';
import { timeout } from 'rxjs/operators';
import { AppConstants } from '../app.constants';
import { SimulationReservationReason, RecapitulatoryComponentModel } from '../module/recapitulatory/model/recapitulatory.model';
import { P5xService } from './p5x.service';
import { SummaryService } from './summary.service';
import { SectionService } from './section.service';
import {
  RecallConfirmationDialogComponent
} from '../shared/components/dialogs/recall-confirmation-dialog/recall-confirmation-dialog.component';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  //#region variables
  public pdfDocument: string;
  public fniceNo: string;
  public noClient: string;
  pdffilestatus : any;
  accountNumber: string;
  isHouse: boolean;
  isApartment: boolean;
  houseAttic: boolean;
  apartmentIndoorGarages: boolean;
  Garageinteriorquestion: any;
  houseorApartmentNatureFlooring: boolean;
  public documentModel: DocumentModel;
  public incendieModel: CreerDossierIncendie;
  public garantyBatiment: GarantiesBatiment;
  public garantyContent: GarantiesContenu;
  public garantyContractModel: GarantiesContrat;
  public garantyTariff: GarantieTarifee;
  public email: Email;
  aircoQuestion: any;
  liftQuestion: any;
  housebasementcheck: any;
  contactDetails: ContactDetails;
  intermediatenumber = '0';
  basic: string | string[];
  propCodePostal: string;
  PropcommuneLibelle: string;
  //#endregion

  //#region methods
  constructor(
    private http: HttpClient, private saveService: SaveService, private globals: Globals,
    private guaranteeservice: GuaranteeService, private characteristicService: CharacteristicService,
    private signatureService: SignatureService, private guaranteeService: GuaranteeService,
    private p5xService: P5xService, private summaryService: SummaryService,
    private translate: TranslateService,
    private sectionService: SectionService, private matDialog: MatDialog) {
    this.documentModel = new DocumentModel();
    this.incendieModel = new CreerDossierIncendie();
    this.garantyContractModel = new GarantiesContrat();
    this.garantyContent = new GarantiesContenu();
    this.garantyBatiment = new GarantiesBatiment();
    this.garantyTariff = new GarantieTarifee();
    this.email = new Email();
  }

  setAccountNumber(value: string) {
    this.accountNumber = value;
  }

  getAccountNumber(): string {
    return this.accountNumber;
  }

  setIsHouse(value: boolean) {
    this.isHouse = value;
  }

  getIsHouse(): boolean {
    return this.isHouse;
  }

  setIsApartment(value: boolean) {
    this.isApartment = value;
  }

  getIsApartment(): boolean {
    return this.isApartment;
  }

  setHouseAttic(value: boolean) {
    this.houseAttic = value;
  }

  getHouseAttic(): boolean {
    return this.houseAttic;
  }

  setApartmentIndoorGarages(value: boolean) {
    this.apartmentIndoorGarages = value;
  }

  getApartmentIndoorGarages(): boolean {
    return this.apartmentIndoorGarages;
  }

  setHouseOrApartmentNatureFlooring(value: boolean) {
    this.houseorApartmentNatureFlooring = value;
  }

  getHouseOrApartmentNatureFlooring(): boolean {
    return this.houseorApartmentNatureFlooring;
  }

  callDocumentumFromP5XServiceRecall(clientId, simulationToken, language, dialogRef, recallConfirmationDetails) {
    let postalCode;
    const country = this.signatureService.getSaveAddress1().Taker_Address_Country;
    if (country === 'BELGIQUE' || country === 'BELGIE' || country === 'BELGIEN') {
      postalCode = this.signatureService.getPropertyPostalCode();
    } else {
      postalCode = this.globals.propertyPostCode; //this.saveService.getContactDetails().PostalCode;
    }
    this.globals.showLoaderText = true;
    this.globals.showprojectText = true;
    this.signatureService.getintermediate(postalCode).subscribe((response1) => {
      // console.log('intermediate:' + response1);
      const noIntermediaire = response1.GetMainOfficeForCPListResponse.GetMainOfficeForCPListResult.uspGetMainOfficeForCPListResult[0].ID_IMD; //response1.GetMainIntermediateByZipResponse.Number;
      this.callDocumentumAPI(noIntermediaire).subscribe((response3) => {
        this.pdfDocument = response3.DocumentPDF;
        this.fniceNo = response3.NoDossier; // + response3.NoSituation;
        this.noClient = response3.NoClient.replaceAll('|','');
        const saveCriteria = this.signatureService.getSaveCriteria();
        saveCriteria.FNICEFile = this.fniceNo;
        saveCriteria.NoClient = this.noClient;
        this.signatureService.setSaveCriteria(saveCriteria);
        const contactDetails = this.saveService.getContactDetails();
        const saveRequest = {
          firstName: contactDetails.FirstName,
          lastName: contactDetails.LastName,
          email: contactDetails.EmailAddress,
          phone: contactDetails.Telephone,
          code: contactDetails.PostalCode
        };
        this.saveService.setProjectStatus('Project Reserved');
        // this.sectionService.setCurrentPage('P4-2'); //'P5X');
        this.globals.sendSimulationMail = false;
        this.saveService.saveSimulation(saveRequest, 'ReserveRecall').subscribe((data) => {
          this.saveService.setSimulationToken(data.Tocken);
          this.saveService.setProspectNumber(data.CRMProspect);
            this.saveService.setShortToken(data.shortTocken);
            this.p5xService.setDocumentGenerateStatus(true);
          dialogRef.close(true);
          this.matDialog.open(RecallConfirmationDialogComponent, { data: recallConfirmationDetails });
        });
        this.globals.showLoaderText = false;       
      }, (error) => {
        dialogRef.close(true);
        const input = {
          title: this.translate.instant('Msg_Error_Title'), 
          errorMessage: this.translate.instant('Msg_Service_Error'),
          disableClose: false};
        this.characteristicService.serverFailError(input);
      });
    });
  }

  callDocumentumFromSignature(clientId, simulationToken, language) {
    let postalCode;
    const country = this.signatureService.getSaveAddress1().Taker_Address_Country;
    if (country === 'BELGIQUE' || country === 'BELGIE' || country === 'BELGIEN') {
      postalCode = this.signatureService.getPropertyPostalCode();
    } else {
      postalCode = this.globals.propertyPostCode; // this.saveService.getContactDetails().PostalCode;
    }
    this.globals.showLoaderText = true;
    this.globals.showprojectText = true;
    this.signatureService.getintermediate(postalCode).subscribe((response1) => {
      // console.log('intermediate:' + response1);
      let noIntermediaire;
      if(this.signatureService.getnoIntermediate() !== null){
        noIntermediaire = this.signatureService.getnoIntermediate();
      }
      else
      {
        noIntermediaire = response1.GetMainOfficeForCPListResponse.GetMainOfficeForCPListResult.uspGetMainOfficeForCPListResult[0].ID_IMD; // response1.GetMainIntermediateByZipResponse.Number;
      }

      this.callDocumentumAPI(noIntermediaire).subscribe((response3) => {
        const creationReussie = response3.CreationReussie;
        if (creationReussie) {
          this.pdfDocument = response3.DocumentPDF;
          this.fniceNo = response3.NoDossier; // + response3.NoSituation;
          this.noClient = response3.NoClient.replaceAll('|','');
          //this.noClient = this.noClient.replace('|','');
          const etatSituation = response3.EtatSituation;
          if (etatSituation === 'EMIS' && (this.pdfDocument !== undefined && this.pdfDocument !== null && this.pdfDocument !== '')) {

            const saveCriteria = this.signatureService.getSaveCriteria();
            saveCriteria.FNICEFile = this.fniceNo;
            saveCriteria.NoClient = this.noClient;
            this.signatureService.setSaveCriteria(saveCriteria);
            const contactDetails = this.saveService.getContactDetails();
            const saveRequest = {
              firstName: contactDetails.FirstName,
              lastName: contactDetails.LastName,
              email: contactDetails.EmailAddress,
              phone: contactDetails.Telephone,
              code: contactDetails.PostalCode
            };
            this.saveService.setProjectStatus('Project Completed');
            this.saveService.setSimulationStatus('Project Completed');
            this.p5xService.setDocumentGenerateStatus(true);
            this.sectionService.setCurrentPage('P5-6');
            this.signatureService.savePdfBytestoFilePath(this.pdfDocument, this.fniceNo).subscribe((response) => {
              this.pdffilestatus = response;
            });
            this.globals.sendSimulationMail = false;
            this.saveService.saveSimulation(saveRequest, 'Save').subscribe((data) => {
              this.saveService.setSimulationToken(data.Tocken);
              this.saveService.setProspectNumber(data.CRMProspect);
              this.saveService.setShortToken(data.shortTocken);
              this.signatureService.setShowSignaturePrevious(false);
              //this.signatureService.setShowSignatureNext(true);
              this.signatureService.setSignatureCurrentPage(false, false, false, false, false, true, false, false);
              // this.signatureService.setSignatureCurrentPage(false, false, false, false, true, false, false);
            });
          } else {
            const saveCriteria = this.signatureService.getSaveCriteria();
            saveCriteria.FNICEFile = this.fniceNo;
            saveCriteria.NoClient = this.noClient;
            this.signatureService.setSaveCriteria(saveCriteria);
            const contactDetails = this.saveService.getContactDetails();
            const saveRequest = {
              firstName: contactDetails.FirstName,
              lastName: contactDetails.LastName,
              email: contactDetails.EmailAddress,
              phone: contactDetails.Telephone,
              code: contactDetails.PostalCode
            };
            this.saveService.setProjectStatus('Project Reserved');
            this.saveService.setSimulationStatus('Project Reserved');
            const simulationReservationReason: SimulationReservationReason = {
              ID: AppConstants.SimulationReservationReason.ProjectReserved.ID,
              Text: AppConstants.SimulationReservationReason.ProjectReserved.Text
            };
            this.p5xService.setSimulationReservationReason(simulationReservationReason);
            this.globals.sendSimulationMail = false;
            this.saveService.saveSimulation(saveRequest, 'ReserveRecall').subscribe((data) => {
              this.p5xService.setDocumentStatus(true);
              this.p5xService.setDocumentGenerateStatus(true);
              this.globals.p5xPrvDisable = true;
              this.navigateToP5X(simulationReservationReason, clientId, simulationToken, language);
              this.p5xService.setDisableP5XPrevious(true); //disable P5x Prev button for reservation reasonid 11
            });
          }
        } else {
            // const contactDetails = this.saveService.getContactDetails();
            // const saveRequest = {
            //   firstName: contactDetails.FirstName,
            //   lastName: contactDetails.LastName,
            //   email: contactDetails.EmailAddress,
            //   phone: contactDetails.Telephone,
            //   code: contactDetails.PostalCode
            // };
            // this.saveService.setProjectStatus('Project Reserved');
            // this.saveService.setSimulationStatus('Project Reserved');
            // this.saveService.setSimulationStatus('Project Reserved');
            // const simulationReservationReason: SimulationReservationReason = {
            //   ID: AppConstants.SimulationReservationReason.ProjectReserved.ID,
            //   Text: AppConstants.SimulationReservationReason.ProjectReserved.Text
            // };
            // this.saveService.saveSimulation(saveRequest, 'ReserveRecall').subscribe((data) => {
            //   this.p5xService.setDocumentStatus(true);
            //   this.p5xService.setDocumentGenerateStatus(true);
            //   this.globals.p5xPrvDisable = true;
            //   this.navigateToP5X(simulationReservationReason, clientId, simulationToken, language);
            //   this.p5xService.setDisableP5XPrevious(true); //disable P5x Prev button for reservation reasonid 11
            // });
            const input = {
              title: this.translate.instant('Msg_Error_Title'), 
              errorMessage: this.translate.instant('Project_Creation_Failed'),
              disableClose: false};
            this.characteristicService.serverFailError(input);
        }
        this.globals.showLoaderText = false;
        // this.fniceNo = new Date().getHours().toString() +
        //   new Date().getMinutes().toString() + new Date().getSeconds().toString() +
        //   new Date().getMilliseconds().toString(); // response3.noDossier + response3.noSituation;
      }, (error) => {
        const input = {
          title: this.translate.instant('Msg_Error_Title'), 
          errorMessage: this.translate.instant('Project_Creation_Failed'),
          disableClose: false};
        this.characteristicService.serverFailError(input);
      });
    });
  }

  navigateToP5X(simulationReservationReason: SimulationReservationReason, clientId, simulationToken, language) {
    this.p5xService.setSimulationReservationReason(simulationReservationReason);
    const recapitulatoryComponent: RecapitulatoryComponentModel = {
      RecapitulatoryQuestion1: false, RecapitulatoryQuestion2: true
    };
    this.summaryService.setRecapitulatoryComponent(recapitulatoryComponent);
    this.p5xService.setIsP5XPage(true);    
    this.p5xService.setP5XProgressBarDetails();
    if(this.globals.isMobile)
    {this.p5xService.setmobileP5XProgressBarDetails();}
      this.sectionService.navigate('recapitulatory', clientId, simulationToken, language);
      this.p5xService.setDisableP5XPrevious(true);
  }

  callDocumentumAPI(noIntermediaire) {
    this.contactDetails = this.saveService.getContactDetails();
    const data = JSON.parse(sessionStorage.getItem('jsonData'));
    const propertyType = data.Sections.find(obj => obj.SectionKey === 'S1').
      QuestionGroup.find(obj => obj.GroupKey === 'G3').
      Questions.find(obj => obj.QuestionKey === 'Property_Type_Question').Answers;

    if (propertyType[0].Answerkey === 'Property_Type_House') {
      const facades = data.Sections.find(obj => obj.SectionKey === 'S1').
        QuestionGroup.find(obj => obj.GroupKey === 'G4').
        Questions.find(obj => obj.QuestionKey === 'House_Number_Facades_Question').Answers[0].AnswerText;

      this.incendieModel.NbrFacade = facades;

      const indoorAnswers = data.Sections.find(obj => obj.SectionKey === 'S2.1').
        QuestionGroup.find(obj => obj.GroupKey === 'G7').Questions.find(obj => obj.QuestionKey === 'House_Indoor_Features_Block').Answers;
      const firstAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.1').
        QuestionGroup.find(obj => obj.GroupKey === 'G6').Questions.find(obj => obj.QuestionKey === 'House_Rooms_Question').Answers;
      this.incendieModel.NbrPiecesRDCEtage = +(firstAnswer[0].AnswerText);
      const secondAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.1').
        QuestionGroup.find(obj => obj.GroupKey === 'G6').
        Questions.find(obj => obj.QuestionKey === 'House_Shelters_Question').Answers;
      this.incendieModel.NbrAbrisJardinCarPort = secondAnswer[0].AnswerText;
      const thirdAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.1').
        QuestionGroup.find(obj => obj.GroupKey === 'G6').
        Questions.find(obj => obj.QuestionKey === 'House_Annex_Less_50_Question').Answers;
      this.incendieModel.NbrAnnexes = thirdAnswer[0].AnswerText;

      if (indoorAnswers != null) {
        this.aircoQuestion = indoorAnswers.find(obj => obj.ChoiceId === 20);
        this.liftQuestion = indoorAnswers.find(obj => obj.ChoiceId === 21);
        this.housebasementcheck = indoorAnswers.find(obj => obj.ChoiceId === 22)
        // this.incendieModel.SousSol = indoorAnswers.find(obj => obj.ChoiceId === 21) != null ? true : false;
        // this.incendieModel.ToitureArdoisePailleChaume = indoorAnswers.find(obj => obj.ChoiceId === 21) != null ? true : false;
      }

      this.incendieModel.AircoChauffageSolPompeAChaleur = this.aircoQuestion != null ? true : false;
      this.incendieModel.Ascenceur = this.liftQuestion != null ? true : false;
      this.incendieModel.SousSol = this.housebasementcheck != null ? true : false;

      const outdoorAnswers = data.Sections.find(obj => obj.SectionKey === 'S2.1').
        QuestionGroup.find(obj => obj.GroupKey === 'G8').
        Questions.find(obj => obj.QuestionKey === 'House_Outdoor_Features_Block').Answers;

      if (outdoorAnswers != null) {
        this.incendieModel.ToitureArdoisePailleChaume = outdoorAnswers.find(obj => obj.ChoiceId === 26) != null ? true : false;
        this.incendieModel.PiscineExterieure = outdoorAnswers.find(obj => obj.ChoiceId === 24) != null ? true : false;
        this.incendieModel.PanneauxPhotovoltaiques = outdoorAnswers.find(obj => obj.ChoiceId === 25) != null ? true : false;
      }

      const someOtherAnswers = data.Sections.find(obj => obj.SectionKey === 'S2.1').
        QuestionGroup.find(obj => obj.GroupKey === 'G10').
        Questions.find(obj => obj.QuestionKey === 'House_Some_Other_Question_Block').Answers;

      if (someOtherAnswers != null) {
        this.incendieModel.PiscineInterieure =
          someOtherAnswers.findIndex(obj => obj.Answerkey === 'House_Property_Indoor_Pool_Question') >= 0 ? true : false;

        this.incendieModel.PiecesAUsagePrfeossionnel =
          someOtherAnswers.findIndex(obj => obj.Answerkey === 'House_Property_Professional_Use_Question') >= 0 ? true : false;

        this.incendieModel.BatiementClasse =
          someOtherAnswers.findIndex(obj => obj.Answerkey === 'House_Property_Classified_Question') >= 0 ? true : false;
      }
      const housepostalcodeLocation = data.Sections.find(obj => obj.SectionKey === 'S2.1').
        QuestionGroup.find(obj => obj.GroupKey === 'G9').
        Questions.find(obj => obj.QuestionKey === 'House_Property_Post_Code_Question').Answers;

      const houseLocation = data.Sections.find(obj => obj.SectionKey === 'S2.1').
        QuestionGroup.find(obj => obj.GroupKey === 'G9').
        Questions.find(obj => obj.QuestionKey === 'House_Property_Post_Code_Place_Question').Answers;

      if (housepostalcodeLocation !== null){
          this.propCodePostal = housepostalcodeLocation[0].AnswerText;
        }
      if (houseLocation !== null){
          this.PropcommuneLibelle = houseLocation[0].AnswerText;
        }

    } else {
      this.Garageinteriorquestion = data.Sections.find(obj => obj.SectionKey === 'S2.2').
        QuestionGroup.find(obj => obj.GroupKey === 'G12').
        Questions.find(obj => obj.QuestionKey === 'Apartment_Indoor_Garages_Question').Answers[0].AnswerText;

      const firstAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
        QuestionGroup.find(obj => obj.GroupKey === 'G12').
        Questions.find(obj => obj.QuestionKey === 'Apartment_Rooms_Question').Answers;
      this.incendieModel.NbrPiecesAppartement = firstAnswer[0].AnswerText;

      const secondAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
        QuestionGroup.find(obj => obj.GroupKey === 'G12').
        Questions.find(obj => obj.QuestionKey === 'Apartment_Outdoor_Garages_Question').Answers;
      this.incendieModel.NbrGaragesHorsBatiment = secondAnswer[0].AnswerText;

      const someOtherApartmentAnswers = data.Sections.find(obj => obj.SectionKey === 'S2.2').
        QuestionGroup.find(obj => obj.GroupKey === 'G16').
        Questions.find(obj => obj.QuestionKey === 'Apartment_Some_Other_Question_Block').Answers;

        const apartmentindoorAnswers = data.Sections.find(obj => obj.SectionKey === 'S2.2').
        QuestionGroup.find(obj => obj.GroupKey === 'G13').Questions.find(obj => obj.QuestionKey === 'Apartment_Indoor_Features_Block').Answers;

      const apartmentOutdoorAnswers = data.Sections.find(obj => obj.SectionKey === 'S2.2').
        QuestionGroup.find(obj => obj.GroupKey === 'G14').
        Questions.find(obj => obj.QuestionKey === 'Apartment_Outdoor_features_Block').Answers;

      if (someOtherApartmentAnswers != null) {
        this.incendieModel.PiecesAUsagePrfeossionnel =
          someOtherApartmentAnswers.findIndex(obj => obj.Answerkey === 'Apartment_Property_Professional_Use_Question') >= 0 ? true : false;
        this.incendieModel.BatiementClasse =
          someOtherApartmentAnswers.findIndex(obj => obj.Answerkey === 'Apartment_Property_Classified_Question') >= 0 ? true : false;
      }
      if (apartmentindoorAnswers!= null){
        this.incendieModel.AircoChauffageSolPompeAChaleur = apartmentindoorAnswers.find(obj => obj.ChoiceId === 37) != null ? true : false;
        this.incendieModel.SousSol = apartmentindoorAnswers.find(obj => obj.ChoiceId === 40) != null ? true : false;
      }

      if (apartmentOutdoorAnswers != null) {
        this.incendieModel.PanneauxPhotovoltaiques =
          apartmentOutdoorAnswers.findIndex(obj => obj.Answerkey === 'Apartment_Photo_Panels_Question') >= 0 ? true : false;

        this.incendieModel.PiscineInterieure =
          apartmentOutdoorAnswers.findIndex(obj => obj.Answerkey === 'Apartment_Indoor_Pool_Question') >= 0 ? true : false;
        
        this.incendieModel.Ascenceur = 
          apartmentOutdoorAnswers.findIndex(obj => obj.Answerkey === 'Apartment_Lift_Question') >= 0 ? true : false;
      }
      const apartmentpostcodeLocation = data.Sections.find(obj => obj.SectionKey === 'S2.2').
        QuestionGroup.find(obj => obj.GroupKey === 'G15').
        Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Question').Answers;

      const apartmentLocation = data.Sections.find(obj => obj.SectionKey === 'S2.2').
        QuestionGroup.find(obj => obj.GroupKey === 'G15').
        Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Place_Question').Answers;

      if (apartmentpostcodeLocation !== null){
          this.propCodePostal = apartmentpostcodeLocation[0].AnswerText;
        }
      if (apartmentLocation !== null){
          this.PropcommuneLibelle = apartmentLocation[0].AnswerText;
        }

      // if (apartmentLocation != null) {
      //   this.incendieModel.CodeLocalite = apartmentLocation[0].AnswerText;
      // }
    }

    const principleResidence = data.Sections.find(obj => obj.SectionKey === 'S1').
      QuestionGroup.find(obj => obj.GroupKey === 'G5').
      Questions.find(obj => obj.QuestionKey === 'Property_Residence_Type_Question').Answers;

    if (principleResidence != null) {
      this.incendieModel.ResidencePrincipale =
        principleResidence.find(obj => obj.Answerkey === 'Property_Residence_Type_Principal') != null ? true : false;
    }
    this.incendieModel.Rue = this.signatureService.getSaveAddress1().Property_Address_Street;
    this.incendieModel.GarageInerieur = (+this.Garageinteriorquestion) > 0 ? true : false;
    this.incendieModel.Branche = '091';

    this.incendieModel.NoSimulation = this.saveService.getShortToken(); //this.saveService.getSimulationToken();
    // new Date().getHours().toString() + new Date().getMinutes().toString() + new Date().getSeconds().toString() + new Date().getMilliseconds().toString();
    const contractdate = this.signatureService.getSaveAddress1().Contract_start_date;
    this.incendieModel.DateEffect = (contractdate !== undefined || contractdate !== '') ? contractdate : null;
    this.incendieModel.DateEntreeService = moment().format('YYYY-MM-DD'); // new Date().toISOString();
    this.incendieModel.DateIndex = moment().format('YYYY-MM-DD'); // new Date().toISOString();
    this.incendieModel.DateTarif = moment().format('YYYY-MM-DD'); // new Date().toISOString();
    this.incendieModel.DatePropositoin = moment().format('YYYY-MM-DD'); // new Date().toISOString();
    this.incendieModel.Langue = this.globals.languagecode;
    this.incendieModel.TypeConstruction = 'TRADI';
    this.incendieModel.TypeContenu = 'GENERAL';
    this.incendieModel.TypeSituation = 'PROJET';
    this.incendieModel.UsageBatiment = 'HABITA';
    if (this.globals.paymentFrequencyanswer === 'annuel' || this.globals.paymentFrequencyanswer === 'jaarlijks') {
      this.incendieModel.Periodicite = 'ANNUEL';
    } else if (this.globals.paymentFrequencyanswer === 'semestriel' || this.globals.paymentFrequencyanswer === 'halfjaarlijks') {
      this.incendieModel.Periodicite = 'SEMESTR';
    } else if (this.globals.paymentFrequencyanswer === 'trimestriel' || this.globals.paymentFrequencyanswer === 'driemaandelijks') {
      this.incendieModel.Periodicite = 'TRIMESTR';
    }

    this.incendieModel.LangueClient = this.guaranteeservice.getLanguage();
    this.incendieModel.MachineName = null;
    this.incendieModel.NomPage = null;
    this.incendieModel.PageId = 'FedFormsFire';
    const userid = environment.esbuser;
    this.incendieModel.Utilisateur = userid; //'BARTH';
    this.incendieModel['_xmlns:ns0'] = 'http://AFV.ESB.Biz.CALASS.JSON';
    this.incendieModel.__prefix = 'ns0';
    this.incendieModel.EtatBatiment = 'NORMAL';
    this.incendieModel.TarifBuilding = false;
    this.incendieModel.CodePays = 'BE';

    if (this.contactDetails !== undefined && this.contactDetails !== null) {
      this.email.From = this.contactDetails.EmailAddress;
      this.email.CC = this.contactDetails.EmailAddress;
      this.email.Subject = 'testmail';
      this.email.To = this.contactDetails.EmailAddress;
    }

    this.incendieModel.Email = this.email;
    this.incendieModel.CapitalBatiment = this.guaranteeservice.getInitialPricingData().Evaluation.
    CapitalBatimentEvalue.replace(',', '.');
    if (this.guaranteeservice.getUpdatedPricingData() !== undefined && this.guaranteeservice.getUpdatedPricingData() !== null) {
      this.incendieModel.CapitalContenu = this.guaranteeservice.getUpdatedPricingData().
        Tarification.CapitalContenuEvalue.replace(',', '.');
    } else {
      this.incendieModel.CapitalContenu = this.guaranteeservice.getInitialPricingData().
        Tarification.CapitalContenuEvalue.replace(',', '.');
    }
    this.incendieModel.CapitalBatimentEvalue = this.guaranteeservice.getInitialPricingData().
      Evaluation.CapitalBatimentEvalue.replace(',', '.');
    this.incendieModel.CapitalContenuEvalue = this.guaranteeservice.getInitialPricingData().
      Evaluation.CapitalContenuEvalue.replace(',', '.');
    const codetype = this.guaranteeservice.getCodeTypeContiguite();
    this.incendieModel.CodeTypeContiguite = (codetype === '' || codetype === null || codetype === undefined) ? '2BATHAB' : codetype;
    const natureAutruiAbandonRecours = this.guaranteeservice.getNatureAutruiAbandonRecours();
    const natureautriRecourscheck = this.guaranteeService.getNatureAbandonRecoursCheck();
    this.incendieModel.NatureAutruiAbandonRecours = natureautriRecourscheck === false ? null : 'LOCAT';
    // this.incendieModel.NatureAutruiAbandonRecours = natureAutruiAbandonRecours === '' ? null : natureAutruiAbandonRecours;
    this.incendieModel.NaturePreneur = this.guaranteeservice.getNaturePreneur();
    this.incendieModel.NaturePreneurContenu = this.guaranteeservice.getNaturePreneurContenu();
    if (this.guaranteeservice.getUpdatedPricingData() !== undefined && this.guaranteeservice.getUpdatedPricingData() !== null) {
      this.incendieModel.AlarmeAgreeIncert =
      this.guaranteeservice.getUpdatedPricingData().Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked;
    }else{
    this.incendieModel.AlarmeAgreeIncert =
      this.guaranteeservice.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked;
    }
    // this.incendieModel.NbrAppartment = this.getIsApartment() ? 1 : 0;
    // this.incendieModel.critAcceptvide = 'critAccepBatimentInhabite';
    const isCRMCustomer = this.characteristicService.getClientIdOrSimulationTokenPresent();
    this.incendieModel.origine = isCRMCustomer ? 'MYFEDERALE' : 'WEB';
    this.incendieModel.OrigineCanalDistribution = isCRMCustomer ? 'MYFEDERALE' : 'WEB';
    this.incendieModel.TypeVente = 'DIST';
    this.incendieModel.TypeLocation = this.guaranteeService.getPropertyDestinationRenting() ? 'TOTAL' : 'NON';
    

    // const guaranteeBatimentTarif: GarantieTarifee[] = this.guaranteeservice.getGuaranteeBatiment();
    // const guaranteeBatiment: GarantiesBatiment = { GarantieTarifee: guaranteeBatimentTarif };
    // this.incendieModel.GarantiesBatiment = guaranteeBatiment;

    // const guaranteeContenuTarif: GarantieTarifee[] = this.guaranteeservice.getGuaranteeContent();
    // const guaranteeContenu: GarantiesContenu = { GarantieTarifee: guaranteeContenuTarif };
    // this.incendieModel.GarantiesContenu = guaranteeContenu;

    // const guaranteeContratTarif: GarantieTarifee[] = this.guaranteeservice.getGuaranteeContract();
    // const guaranteeContrat: GarantiesContrat = { GarantieTarifee: guaranteeContratTarif };
    // this.incendieModel.GarantiesContrat = guaranteeContrat;

    this.incendieModel.GarantiesBatiment = this.getGarantiesBatiment();
    this.incendieModel.GarantiesContenu = this.getGarantiesContenu();
    this.incendieModel.GarantiesContrat = this.getGuaranteeContrat();

    if (this.getIsHouse()) {
      this.incendieModel.Grenier = this.getHouseAttic();
    }
    this.incendieModel.SolEnParquetPierreNaturelle = this.getHouseOrApartmentNatureFlooring();
    this.incendieModel.TypeBatiment = this.getIsHouse() ? 'MAISON' : 'PARTIEBATI';
    if (this.getIsApartment()) {
      this.incendieModel.NbrGaragesDansBatiment = this.getApartmentIndoorGarages();
    }

    const prospectnum = this.saveService.getProspectNumber();
    const accountNumber = this.getAccountNumber();
    const prospectcheck = Number(prospectnum);

    if (isNaN(prospectcheck)) {
      this.incendieModel.NoClient = null;
      this.incendieModel.NoProspectCRM = prospectnum !== undefined ? prospectnum : null;
    } else {
      this.incendieModel.NoClient = accountNumber !== undefined ? +accountNumber : +prospectnum;
      this.incendieModel.NoProspectCRM = null;
    }
    // const accountNumber = this.getAccountNumber();
    // this.incendieModel.NoClient = accountNumber !== undefined ? +accountNumber : null; //500061; // 6060;
    // const prospectnum = this.saveService.getProspectNumber();    
    // if (accountNumber !== undefined)
    // { this.incendieModel.NoProspectCRM = null; } else
    // { this.incendieModel.NoProspectCRM = prospectnum !== undefined ? prospectnum : null; }

    this.incendieModel.LibelleRueID = null; // '123457';
    this.incendieModel.CodePostal = this.propCodePostal; //this.signatureService.getPropertyPostalCode();
    this.incendieModel.CommuneLibelle = this.PropcommuneLibelle; //this.signatureService.getPropertyPostalCodePlace();
    this.incendieModel.NumeroBoite = this.signatureService.getSaveAddress1().Property_Address_Box;
    this.incendieModel.NumeroImmeuble = this.signatureService.getSaveAddress1().Property_Address_Street_Number;
    const signature4Answers = this.signatureService.getSignature4Answers();

    if (signature4Answers !== undefined)
    {
      this.incendieModel.critAccepContratPrecedemmentResilie = 
      signature4Answers.SecondCheckbox !== undefined ? signature4Answers.SecondCheckbox : false;
      this.incendieModel.critAccepBatimentJamaisAssure = 
      signature4Answers.ThirdCheckbox !== undefined ? signature4Answers.ThirdCheckbox : false;
      // this.incendieModel.DescriptionSpecifique = 
      // signature4Answers.RequirementText !== undefined ? signature4Answers.RequirementText : null ;
      this.incendieModel.DemandeSpecifique = 
      signature4Answers.RequirementText !== undefined ? signature4Answers.RequirementText : null ;
      this.incendieModel.CritAccepPreneurEnFaillite = 
      signature4Answers.FourthCheckbox !== undefined ? signature4Answers.FourthCheckbox : false ;
      this.incendieModel.CritAccepSinistreDansLesTroisDernieresAnnees = 
      signature4Answers.FirstCheckbox !== undefined ? signature4Answers.FirstCheckbox : false;
    } else
    {
      this.incendieModel.critAccepContratPrecedemmentResilie = false;
      this.incendieModel.critAccepBatimentJamaisAssure = false;
      // this.incendieModel.DescriptionSpecifique = null ;
      this.incendieModel.DemandeSpecifique = null;
      this.incendieModel.CritAccepPreneurEnFaillite = false ;
      this.incendieModel.CritAccepSinistreDansLesTroisDernieresAnnees = false;
    }
    

    this.incendieModel.critAccepBatimentInhabite = false;
    this.incendieModel.critAccepRisqueCaravane = false;    
    this.incendieModel.CritAcceoBatimentJamaisAssure = false;
    // this.incendieModel.CritAccepSinistreDansLesTroisDerniere = false;
    this.incendieModel.critAccepBatimentClasse = false;
    this.incendieModel.MethodEvaluationBatiement = this.getIsHouse() ? 'GRMAISON' : 'GRAPPART';

    const initialPricingData = this.guaranteeService.getInitialPricingData();
    const updatedPricingData = this.guaranteeService.getUpdatedPricingData();
  
    if (updatedPricingData !== undefined && updatedPricingData !== null) {
      if (updatedPricingData.Tarification.Premium_VAT_Fire_Content_Checked) 
      { this.incendieModel.MethodEvaluationContenu = 'CAPBAT30';}
      else { this.incendieModel.MethodEvaluationContenu = null;}
    }
    else {
      if (initialPricingData !== undefined && initialPricingData !== null) {
      if (initialPricingData.Tarification.Premium_VAT_Fire_Content_Checked) 
      { this.incendieModel.MethodEvaluationContenu = 'CAPBAT30';}
      else { this.incendieModel.MethodEvaluationContenu = null;}
      }
      else {this.incendieModel.MethodEvaluationContenu = null; }
    }

    // this.incendieModel.MethodEvaluationContenu = this.guaranteeService.getContentCovering() ? 'CAPBAT30' : null;
    this.incendieModel.emailClient = this.signatureService.getSaveAddress1().Simulation_mail_Contact;
    // this.incendieModel.EtatSituation = 'EMIS';
    this.incendieModel.AnnexeGE50 = false;

    this.documentModel.CreerDossierIncendie = this.incendieModel;

    //this.incendieModel.NoIntermediaire = '1501000';
    this.incendieModel.NoProducteur = '1501000';
    this.incendieModel.NoIntermediaire = noIntermediaire.substring(0, 7);
    const codelocal = this.globals.locationData.Locations.filter(obj =>
      obj.PostalCode === this.incendieModel.CodePostal &&
      (obj.LibelleFR === this.incendieModel.CommuneLibelle || obj.LibelleNL === this.incendieModel.CommuneLibelle));
    (codelocal.length > 0) ? this.incendieModel.CodeLocalite = codelocal[0].NumeroLocalite : this.incendieModel.CodeLocalite = '0';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', timeout: '50000' });
    return this.http.post<any>(environment.apiURL + 'api/Simulation/CallDocumentum', this.documentModel.CreerDossierIncendie, { headers });
  }

  getGarantiesBatiment(): GarantiesBatiment {
    const initialPricingData = this.guaranteeService.getInitialPricingData();
    const updatedPricingData = this.guaranteeService.getUpdatedPricingData();
    // let guaranteeBatimentTarif: GarantieTarifee[] = this.guaranteeservice.getGuaranteeBatiment();
    let guaranteeBatimentTarif: GarantieTarifee[] = JSON.parse(sessionStorage.getItem('garantiesBatiment'));
    if (updatedPricingData !== undefined && updatedPricingData !== null) {
      if (!updatedPricingData.Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Checked) {
        guaranteeBatimentTarif = guaranteeBatimentTarif.filter(obj => obj.RegrDivision !== '091-ABDREC');
      }
    } else {
      if (!initialPricingData.Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Checked) {
        guaranteeBatimentTarif = guaranteeBatimentTarif.filter(obj => obj.RegrDivision !== '091-ABDREC');
      }
    }
    const guaranteeBatiment: GarantiesBatiment = { GarantieTarifee: guaranteeBatimentTarif };
    return guaranteeBatiment;
  }

  getGarantiesContenu(): GarantiesContenu {
    const initialPricingData = this.guaranteeService.getInitialPricingData();
    const updatedPricingData = this.guaranteeService.getUpdatedPricingData();
    // let guaranteeContenuTarif: GarantieTarifee[] = this.guaranteeservice.getGuaranteeContent();
    let guaranteeContenuTarif: GarantieTarifee[] =JSON.parse(sessionStorage.getItem('garantiesContent'));
    let guaranteeContenuTarif1: GarantieTarifee[] = [];
    let guaranteeContenuTarif2: GarantieTarifee[] = [];
    if (updatedPricingData !== undefined && updatedPricingData !== null) {
      if (updatedPricingData.Tarification.Premium_VAT_Fire_Content_Checked) {
        guaranteeContenuTarif1 = guaranteeContenuTarif.filter(obj => obj.RegrDivision !== '091-VOL' && obj.RegrDivision !== '091-VAN');
      }
      if (updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Checked) {
        guaranteeContenuTarif2 = guaranteeContenuTarif.filter(obj => obj.RegrDivision === '091-VOL');
      }
    } else {
      if (initialPricingData.Tarification.Premium_VAT_Fire_Content_Checked) {
        guaranteeContenuTarif1 = guaranteeContenuTarif.filter(obj => obj.RegrDivision !== '091-VOL' && obj.RegrDivision !== '091-VAN');
      }
      if (initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked) {
        guaranteeContenuTarif2 = guaranteeContenuTarif.filter(obj => obj.RegrDivision === '091-VOL');
      }
    }
    guaranteeContenuTarif.length = 0;
    if (guaranteeContenuTarif1.length > 0) {
      guaranteeContenuTarif = guaranteeContenuTarif.concat(guaranteeContenuTarif1);
    }
    if (guaranteeContenuTarif2.length > 0) {
      guaranteeContenuTarif = guaranteeContenuTarif.concat(guaranteeContenuTarif2);
    }
    const guaranteeContenu: GarantiesContenu = { GarantieTarifee: guaranteeContenuTarif };
    return guaranteeContenu;
  }

  getGuaranteeContrat(): GarantiesContrat {
    const initialPricingData = this.guaranteeService.getInitialPricingData();
    const updatedPricingData = this.guaranteeService.getUpdatedPricingData();
    // let guaranteeContratTarif: GarantieTarifee[] = this.guaranteeservice.getGuaranteeContract();
    let guaranteeContratTarif: GarantieTarifee[] = JSON.parse(sessionStorage.getItem('garantiesContract'));
    let guaranteeContratTarif1: GarantieTarifee[] = [];
    let guaranteeContratTarif2: GarantieTarifee[] = [];
    let guaranteeContratTarif3: GarantieTarifee[] = [];
    if (updatedPricingData !== undefined && updatedPricingData !== null) {
      if (updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked) {
        guaranteeContratTarif1 = guaranteeContratTarif.filter(obj => obj.RegrDivision === '091-PJ');
      }
      if (updatedPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked) {
        guaranteeContratTarif2 = guaranteeContratTarif.filter(obj => obj.RegrDivision === '091-RMBFRA');
      }
      if (updatedPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked) {
        guaranteeContratTarif3 = guaranteeContratTarif.filter(obj => obj.RegrDivision === '091-P-IND');
      }
    } else {
      if (initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked) {
        guaranteeContratTarif1 = guaranteeContratTarif.filter(obj => obj.RegrDivision === '091-PJ');
      }
      if (initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked) {
        guaranteeContratTarif2 = guaranteeContratTarif.filter(obj => obj.RegrDivision === '091-RMBFRA');
      }
      if (initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked) {
        guaranteeContratTarif3 = guaranteeContratTarif.filter(obj => obj.RegrDivision === '091-P-IND');
      }
    }
    guaranteeContratTarif.length = 0;
    if (guaranteeContratTarif1.length > 0) {
      guaranteeContratTarif = guaranteeContratTarif.concat(guaranteeContratTarif1);
    }
    if (guaranteeContratTarif2.length > 0) {
      guaranteeContratTarif = guaranteeContratTarif.concat(guaranteeContratTarif2);
    }
    if (guaranteeContratTarif3.length > 0) {
      guaranteeContratTarif = guaranteeContratTarif.concat(guaranteeContratTarif3);
    }
    const guaranteeContrat: GarantiesContrat = { GarantieTarifee: guaranteeContratTarif };
    return guaranteeContrat;
  }
  //#endregion
}
